module.exports = __webpack_public_path__ + "img/networkEng.89c02343.webp";